import { SETUP_CATEGORY } from '../../checklistCategories';
import type { ApprovalQueueItem } from '../../types';

import type { SetupChecklistRow } from './types';

export function buildSetupQueueItem(row: SetupChecklistRow): ApprovalQueueItem {
  return {
    categoryId: SETUP_CATEGORY.id,
    categoryLabel: SETUP_CATEGORY.label,
    description: row.summary,
    details: row.evidence.map((evidence) => ({ label: evidence.label, value: evidence.value })),
    id: row.id,
    title: row.field,
  };
}

export function getSetupSearchText(row: SetupChecklistRow) {
  return [row.field, row.rule, row.summary, row.statusLabel, ...row.evidence.map((evidence) => evidence.value)]
    .filter(Boolean)
    .join(' ');
}
